import { Colors } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

export default class ChooseAvatar extends Lightning.Component {
  static _template() {
    return {
      Title: { y: 425, x: 360 },
      Border: {
        x: 320,
        y: 415,
        collision: true,
        texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
      },
    };
  }

  get _Title() {
    return this.tag('Title');
  }

  get _Border() {
    return this.tag('Border');
  }

  _firstEnable() {
    this._Title.patch({
      color: Colors('#D6D6D6').get(),

      text: {
        text: 'Choose Avatar',
        textColor: Colors('#D6D6D6').get(),
      },
    });
  }

  _focus() {
    this._Title.patch({
      color: Colors('#fafafa').get(),
    });

    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._Title.patch({
      color: Colors('#D6D6D6').get(),
    });

    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'ChooseAvatar');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }
}
